import axios from 'axios'

export const getOffre = (lang: string, alias: string) => axios.post(`/api/ac_residence/information/getOffre?language=${lang}`,
	{
		alias: alias
	}
).then((response) => response.data)
